export enum OrganizationLogModifierField {
    agbCodes = 'agbCodes',
    kgoStatus = 'kgoStatus',
    kvkNumber = 'kvkNumber',
    nameStatutory = 'nameStatutory',
    organizationName = 'organizationName',
    organizationType = 'organizationType',
}
